import React, { Component } from 'react';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import fetchDux from '../../../state/fetch-dux';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import Layout from '../../ui/Layout';
import classNames from 'classnames';
import { actionCreators } from '../../../state/billing-dux';
import CartSummary from './Checkout/CartSummary';
import MetaTags from 'react-meta-tags';
import Loading from '../../ui/Loading';
import trustwave_ssl from '../../../styles/images/trustwave_ssl.jpg';
import MetaLoader from '../../ui/MetaLoader';

const getCardName = cardTypeId => {
  switch (cardTypeId) {
    case 1:
      return 'Mastercard';
    case 2:
      return 'Visa';
    case 3:
      return 'Amex';
    case 8:
      return 'Discover';
    default:
      return 'Unknown';
  }
};

const detectCardName = number => {
  var re = {
    mastercard: /^5[1-5][0-9]{14}$/,
    visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
    amex: /^3[47][0-9]{13}$/,
    discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/
  };
  if (re.mastercard.test(number)) {
    return 'Mastercard';
  } else if (re.visa.test(number)) {
    return 'Visa';
  } else if (re.amex.test(number)) {
    return 'Amex';
  } else if (re.discover.test(number)) {
    return 'Discover';
  } else {
    return 'Unknown';
  }
};

const ReviewAddress = (
  {
    name_first,
    name_last,
    address1,
    address2,
    city,
    stateShort,
    zip,
    zip_4
  }
) => (
  <p>
    {name_first} {name_last} <br />
    {address1}<br />
    {address2 && <span>{address2}<br /></span>}
    {city}, {stateShort} {zip}{zip_4 && `-${zip_4}`}
  </p>
);

const validatePayment = (
  {
    cardId,
    cardNumber,
    expirationMonth,
    expirationYear,
    cvv
  }
) => {
  if (cardId && cardId !== 'new' && cardId > 0) return true;
  const invalid = !cardNumber ||
    (!expirationMonth && expirationMonth !== 0) ||
    !expirationYear ||
    !cvv;
  return !invalid;
};

const getCreditCardLine = (user, payment) => {
  const {
    cardId,
    cardNumber
  } = payment || {};
  if (!cardId || cardId === 'new') {
    return (
      <span>
        {detectCardName(cardNumber)}
        **** **** ****
        {' '}
        {(cardNumber || '').substr((cardNumber || '').length - 4, 4)}
      </span>
    );
  }
  const { CreditCards } = user || {};
  const { LastFour, CardTypeId } = (CreditCards || [])
    .find(({ CardId }) => CardId === cardId) || {};
  return <span>{getCardName(CardTypeId)} **** **** **** {LastFour}</span>;
};

const ShippingSummary = ({ shipping, requestedShipDate, daysToShip }) => {
  const {
    phone,
    giftSenderName,
    giftName,
    giftRecipientEmail,
    giftNote
  } = shipping || {};
  return (
    <div>
      <h5>Shipping Summary</h5>
      <ReviewAddress {...shipping || {}} />
      <h5>Requested Delivery Date</h5>
      <p>
        {moment(requestedShipDate)
          .add(daysToShip || 0, 'days')
          .format('MMMM D, YYYY')}
      </p>
      <h5>Phone</h5>
      <p>{phone}</p>
      {giftSenderName &&
        <div>
          <h5>Gift Sender's Name:</h5>
          <p>{giftSenderName}</p>
        </div>}
      {giftName &&
        <div>
          <h5>Gift Recipient's Name:</h5>
          <p>{giftName}</p>
        </div>}
      {giftRecipientEmail &&
        <div>
          <h5>Gift Recipient's Email:</h5>
          <p>{giftRecipientEmail}</p>
        </div>}
      {giftNote &&
        <div>
          <h5>Gift Message:</h5>
          <p>{giftNote}</p>
        </div>}
    </div>
  );
};

const PickupSummary = ({ shipping, requestedShipDate }) => {
  const {
    name_first,
    name_last
  } = shipping || {};
  return (
    <div>
      <h5>Pickup Summary</h5>
      <ReviewAddress {...shipping || {}} />
      <h5>Requested Pickup Date</h5>
      <p>
        {moment(requestedShipDate).format('MMMM D, YYYY')}
      </p>
      <div>
        <h5>Pickup Agent:</h5>
        <p>
          {name_first}
          {' '}
          {name_last}
        </p>
      </div>
    </div>
  );
};

const location = window.location;

class CheckoutReviewPage extends Component {
  constructor(props) {
    super(props);
    props.clearGetCart();
    props.clearGetCartBilling();
    props.clearGetCartShipping();
    props.clearPostCompleteOrder();
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.getCart();
    this.props.getCartShipping();
    this.props.getCartBilling();
    document.body.classList.add(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-cart-shipping',
      'page-template-page-templatesshop-template-cart-shipping-php',
      'page',
      'page-id-237',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  componentWillUnmount() {
    document.body.classList.remove(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-cart-shipping',
      'page-template-page-templatesshop-template-cart-shipping-php',
      'page',
      'page-id-237',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  render() {
    const scrollToTop = () => window.scrollTo(0, 0);
    const {
      user,
      cart,
      billing = {},
      shipping = {},
      inProgress,
      payment,
      postCompleteOrder,
      submitting,
      order,
      clearBilling,
      redirect
    } = this.props;

    if (redirect) return <Redirect to="/shop/checkout/billing" />;

    const {
      shipper,
      requestedShipDate,
      shipViaId
    } = cart || {};

    const daysToShip = shipViaId == 9 ? 1 : 2;

    const {
      IsWillCall
    } = shipper || {};

    const {
      orderComplete,
      purchaseOrderId,
      resetCart
    } = order || {};

    if (orderComplete) {
      clearBilling();
      return <Redirect to="/shop/checkout/confirmation" />;
    }

    if (resetCart) {
      location.reload();
    }

    const invalidShipDate = moment(requestedShipDate).isBefore(moment());

    const paymentFailed = !orderComplete && !!purchaseOrderId;

    const validPayment = validatePayment(payment || {});

    if (!validPayment) return <Redirect to="/shop/checkout/billing" />;

    const handleCompleteOrder = () => postCompleteOrder(payment);

    return (
      <Layout route="checkout">
        <MetaLoader title="Review | Checkout | Twomey Cellars" />
        <MetaTags>
          <title>Review | Checkout | Twomey Cellars</title>
          <meta property="og:site_name" content="Twomey.com" />
          <meta
            property="og:title"
            content="Review | Checkout | Twomey Cellars"
          />
          <meta property="og:type" content="article" />
          <meta
            property="og:url"
            content="https://twomey.com/shop/checkout/review"
          />
        </MetaTags>
        <div id="content" className="site-content">
          <div id="primary" className="content-area">
            <main id="main" className="site-main shop-page nohero cart-page">
              <div className="container">

                <div className="row">
                  <div className="col-lg-8">

                    <section className="checkout-steps">
                      <div className="row no-gutters">
                        <div className="col">
                          <div className="active">
                            <strong>1</strong>
                            <h5>Shipping & Instructions</h5>
                          </div>
                        </div>
                        <div className="col">
                          <div className="active">
                            <strong>2</strong>
                            <h5>Billing & Payment</h5>
                          </div>
                        </div>
                        <div className="col">
                          <div className="active">
                            <strong>3</strong>
                            <h5>Review & Submit</h5>
                          </div>
                        </div>
                      </div>
                    </section>

                    <h1 className="h3-style column-header">
                      Review & Submit
                    </h1>

                    {inProgress && <Loading fullPage scrollToTop />}
                    {!inProgress &&
                      <div className="account-sections">
                        <form>

                          <p>
                            Please review the information below before submitting. You may go back and edit any information before completing your order.
                          </p>

                          <section className="form-bit">
                            <div className="form-row">
                              <div className="col-md-6">

                                <h5>Billing Summary</h5>
                                <ReviewAddress {...billing || {}} />
                                <h5>Email</h5>
                                <p>{(billing || {}).email}</p>
                                <h5>Phone</h5>
                                <p>{(billing || {}).phone}</p>
                                <h5>Card Number</h5>
                                <p>{getCreditCardLine(user, payment)}</p>

                              </div>
                              <div className="col-md-6">

                                {/* if shipping  */}
                                {!IsWillCall &&
                                  <ShippingSummary
                                    daysToShip={daysToShip}
                                    requestedShipDate={requestedShipDate}
                                    shipping={shipping}
                                  />}
                                {IsWillCall &&
                                  <PickupSummary
                                    daysToShip={daysToShip}
                                    requestedShipDate={requestedShipDate}
                                    shipping={shipping}
                                  />}

                                {(shipping || {}).specialInstructions &&
                                  <div>
                                    <h5>Special Instructions:</h5>
                                    <p>
                                      {(shipping || {}).specialInstructions}
                                    </p>
                                  </div>}

                              </div>
                            </div>
                          </section>
                          {paymentFailed &&
                            <section className="form-bit">
                              <div className="form-row justify-content-end">
                                <div className="col-md-12">
                                  <p
                                    style={{
                                      color: '#dc3545',
                                      padding: '10px 0',
                                      textAlign: 'center'
                                    }}
                                  >
                                    Failed to apply payment. Please review billing information and try again
                                  </p>
                                </div>
                              </div>
                            </section>}

                          <section className="form-bit">
                            {!invalidShipDate &&
                              <div className="form-row justify-content-end">
                                <div className="col-md-4">
                                  <Link
                                    to="/shop/checkout/billing"
                                    className={classNames(
                                      'btn btn-inverse btn-block',
                                      submitting ? 'disabled' : ''
                                    )}
                                  >
                                    Go Back
                                  </Link>
                                </div>
                                <div className="col-md-4">
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-block"
                                    id="tag-button-submit"
                                    onClick={handleCompleteOrder}
                                    disabled={submitting}
                                  >
                                    Complete Order
                                  </button>
                                </div>
                              </div>}
                            {invalidShipDate &&
                              <p style={{ color: 'red' }}>
                                Sorry, your requested
                                {' '}
                                {!IsWillCall ? 'delivery' : 'pickup'}
                                {' '}
                                date is not valid.
                                Please
                                {' '}
                                <Link
                                  style={{ color: 'red' }}
                                  to="/shop/checkout/shipping"
                                >
                                  update the
                                  {' '}
                                  {!IsWillCall ? 'delivery' : 'pickup'}
                                  {' '}
                                  date
                                </Link>
                                {' '}
                                before completing your order.
                              </p>}
                            <div style={{ textAlign: 'center' }}>
                              <br style={{ fontSize: '1.5rem' }} />
                              <img
                                src={trustwave_ssl}
                                style={{ width: '20%' }}
                              />
                            </div>
                          </section>

                        </form>
                      </div>}
                  </div>

                  <div className="col-lg-4">
                    {!inProgress && <CartSummary {...cart} />}
                    <div className="cart-contact">
                      <h4>HAVE QUESTIONS?</h4>
                      <p>We’re here to help Mon-Fri 8am to 5pm PT</p>
                      <p>
                        Call (888) 202 2006 or
                        {' '}
                        <a href="mailto:customercare@twomey.com">email us</a>
                      </p>
                    </div>

                  </div>

                </div>
              </div>
            </main>
          </div>
          <div className="container text-right">
            <a href="#top" className="back-to-top" onClick={scrollToTop}>
              Back to top
            </a>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapState = state => {
  const {
    error: getCartError,
    inProgress,
    result: cart
  } = state.getCart.toJS();

  const {
    error: getCartShippingError,
    inProgress: shippingInProgress,
    result: shipping
  } = state.getCartShipping.toJS();

  const {
    error: getCartBillingError,
    inProgress: billingInProgress,
    result: billing
  } = state.getCartBilling.toJS();

  const payment = state.billing || {};

  const redirect = getCartError || getCartShippingError || getCartBillingError;

  const {
    result: order
  } = state.postCompleteOrder.toJS();

  const {
    result: user
  } = state.postLogin.toJS();

  const {
    inProgress: userInProgress
  } = state.validateLogin.toJS();

  const {
    inProgress: submitting
  } = state.postCompleteOrder.toJS();

  return {
    redirect,
    user,
    order,
    payment,
    cart,
    shipping,
    billing,
    submitting,
    inProgress: inProgress ||
      shippingInProgress ||
      billingInProgress ||
      userInProgress
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      ...actionCreators,
      getCart: fetchDux.getCart.createAction,
      getCartBilling: fetchDux.getCartBilling.createAction,
      getCartShipping: fetchDux.getCartShipping.createAction,
      postCompleteOrder: fetchDux.postCompleteOrder.createAction,
      clearGetCart: fetchDux.getCart.clearAction,
      clearGetCartBilling: fetchDux.getCartBilling.clearAction,
      clearGetCartShipping: fetchDux.getCartShipping.clearAction,
      clearPostCompleteOrder: fetchDux.postCompleteOrder.clearAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(CheckoutReviewPage);
